export enum ReviewDecision {
    Approved = 'Approved',
    Rejected = 'Rejected',
    RequestChanges = 'RequestChanges',
}
